import React, { useEffect } from 'react'
import I18n from 'i18n-js'
import Grid from '@material-ui/core/Grid'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import ConsultantCardProfile from './components/ConsultantCardProfile/ConsultantCardProfile'
import { makeStyles } from '@material-ui/core/styles'
import * as ConsultantAction from './ConsultantAction'
import * as FormAction from './FormAction'

import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import ChooseDate from './components/ChooseDate/ChooseDate'
import ChooseService from './components/ChooseService/ChooseService'
import ContactForm from './components/ContactForm/ContactForm'
import ChooseDateEn from './components/ChooseDate/ChooseDateEn'
import Backdrop from '@material-ui/core/Backdrop'
import Modal from '@material-ui/core/Modal'
import LanguageModalCard from '../Settings/components/Modal/LanguageModalCard'
import CurrencyModalCard from '../Settings/components/Modal/CurrencyModalCard'
import TimezoneModalCard from '../Settings/components/Modal/TimezoneModalCard'
import Hidden from '@material-ui/core/Hidden'
import Drawer from '@material-ui/core/Drawer'
import SettingsScreen from '../Settings/SettingsScreen'
import Container from '@material-ui/core/Container'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_live_51FHeGFHkN3vn8BAmQRL8P6itSjZ0oYrhszS3xigByoKZBpDckrL2nHLJPCupDoMmzKb5C7bAKBDno3y8EiDqzU8c00tzHEap4r')


const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '60%'
		}
	},
	header: {
		[theme.breakpoints.up('md')]: {
			textAlign: 'center'
		}

	},
	row: {
		[theme.breakpoints.up('md')]: {
			borderBottom: '1px solid #E6E8F2'
		}

	},
	card: {
		[theme.breakpoints.down('md')]: {
			borderTop: '1px solid #E6E8F2'
		}
	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	paper: {
		width:516,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 2, 2),
		borderRadius: 20,
		'box-shadow': 'none',
		"&:focus": {
			outline: 'none'
		}
	}
}))

const Consultant = (props) => {
	const dispatch = useDispatch()
	const classes = useStyles()
	const {
		language,
		currency,
		timezone,
		startButton
	} = useSelector(state => state.SettingsReducer)
	const {
		consultantUsername,
		counselingCenterUsername
	} = useParams()

	const {
		service_id,
		time
	} = useSelector(state => state.FormReducer)

	useEffect(() => {
		const newPageTitle = `${consultantUsername} ${I18n.t('settings.htmlTitle')} `
		document.querySelector('title').textContent
			= newPageTitle
		dispatch(FormAction.setConsultantUsername(consultantUsername))
		dispatch(FormAction.setCounselingCenterUsername(counselingCenterUsername))
		dispatch(ConsultantAction.consultantFetch(
			counselingCenterUsername,
			consultantUsername,
			language,
			currency,
			timezone
		))
	}, [])
	const [openLanguageModal, setOpenLanguageModal] = React.useState(false)
	const [openCurrencyModal, setOpenCurrencyModal] = React.useState(false)
	const [openTimezoneModal, setOpenTimezoneModal] = React.useState(false)
	const handleOpenLanguageModal = () => {
		setOpenLanguageModal(true)
	}

	const handleCloseLanguageModal = () => {
		setOpenLanguageModal(false)
	}
	const handleOpenCurrencyModal = () => {
		setOpenCurrencyModal(true)
	}

	const handleCloseCurrencyModal = () => {
		setOpenCurrencyModal(false)
	}
	const handleOpenTimezoneModal = () => {
		setOpenTimezoneModal(true)
	}

	const handleCloseTimezoneModal = () => {
		setOpenTimezoneModal(false)
	}
	const languageModalBody = (
		<div className={classes.paper}>
			<LanguageModalCard handleClose={handleCloseLanguageModal}/>
		</div>
	)
	const currencyModalBody = (
		<div className={classes.paper}>
			<CurrencyModalCard handleClose={handleCloseCurrencyModal}/>
		</div>
	)
	const timezoneModalBody = (
		<div className={classes.paper}>
			<TimezoneModalCard handleClose={handleCloseTimezoneModal}/>
		</div>
	)

	let main = <ChooseService/>

	if (service_id && language === 'fa') {
		main = <ChooseDate/>
	}

	if (service_id && language === 'en') {
		main = <ChooseDateEn/>
	}

	if (time) {
		main =
			<Elements stripe={stripePromise}>
				<ContactForm/>
			</Elements>

	}

	if (!language || !currency || !timezone || startButton === false) {
		return <SettingsScreen/>
	}

	return (
		<div>
			<Grid container justify='center'>
				<div className={classes.root}>
					<ConsultantCardProfile
						history={props.history}
						openLanguageModal={() => {
							handleOpenLanguageModal()
						}}
						openCurrencyModal={() => handleOpenCurrencyModal()}
						openTimezoneModal={() => handleOpenTimezoneModal()}/>
				</div>
			</Grid>
			<Grid container justify='center'>
				<div className={classes.root}>
					{main}
				</div>
			</Grid>
			<Hidden mdUp>
				<Drawer anchor={'bottom'} open={openCurrencyModal} onClose={handleCloseCurrencyModal}>
					{currencyModalBody}
				</Drawer>
			</Hidden>
			<Hidden mdUp>
				<Drawer anchor={'bottom'} open={openLanguageModal} onClose={handleCloseLanguageModal}>
					{languageModalBody}
				</Drawer>
			</Hidden>
			<Hidden mdUp>
				<Drawer anchor={'bottom'} open={openTimezoneModal} onClose={handleCloseTimezoneModal}>
					{timezoneModalBody}
				</Drawer>
			</Hidden>
			<Hidden xsDown>
				<Modal
					aria-labelledby="transition-modal-title"
					aria-describedby="transition-modal-description"
					className={classes.modal}
					open={openCurrencyModal}
					onClose={handleCloseCurrencyModal}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500
					}}
				>
					{currencyModalBody}
				</Modal>
			</Hidden>
			<Hidden xsDown>
				<Modal
					aria-labelledby="transition-modal-title"
					aria-describedby="transition-modal-description"
					className={classes.modal}
					open={openLanguageModal}
					onClose={handleCloseLanguageModal}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500
					}}
				>
					{languageModalBody}
				</Modal>
			</Hidden>


			<Hidden xsDown>
				<Modal
					aria-labelledby="transition-modal-title"
					aria-describedby="transition-modal-description"
					className={classes.modal}
					open={openTimezoneModal}
					onClose={handleCloseTimezoneModal}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500
					}}
				>
					{timezoneModalBody}
				</Modal>
			</Hidden>
		</div>

	)
}

export default Consultant
